export const GeneralInfo = (data) => `
<h5>General Information</h5>

<style>
  .general-table {
    width: 100%;
    border-collapse: collapse;
    page-break-inside: auto;
  }
  .general-table tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .general-table td,
  .general-table th {
    border: 1px solid #000;
    padding: 6px;
    vertical-align: top;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .general-table td div,
  .general-table th div {
    page-break-inside: avoid;
    break-inside: avoid;
  }
</style>

<table class="general-table">
  <tr>
    <td><div><strong>Vendor Name</strong></div></td>
    <td><div>${data.VendorName || "-"}</div></td>
    <td><div><strong>PAN Number</strong></div></td>
    <td><div>${data.PANNumber || "-"}</div></td>
  </tr>
  <tr>
    <td><div><strong>Business Category</strong></div></td>
    <td><div>${data.BusinessCategory || "-"}</div></td>
    <td><div><strong>Vendor Type</strong></div></td>
    <td><div>${data.VendorType || "-"}</div></td>
  </tr>
  <tr>
    <td><div><strong>Vendor Division</strong></div></td>
    <td><div>${data.DivisionName || "-"}</div></td>
    <td></td>
    <td></td>
  </tr>
</table>

<table class="general-table">
  <tr>
    <th><div>Address Type</div></th>
    <th><div>Address</div></th>
    <th><div>City</div></th>
    <th><div>State</div></th>
    <th><div>Pincode</div></th>
  </tr>
  ${data.VendorGeneralAddressDto.map(
    (a) => `
    <tr>
      <td><div>${a.AddressType || "-"}</div></td>
      <td><div>
        ${a.AddressLine1 || ""}
        ${a.AddressLine2 ? `, ${a.AddressLine2}` : ""}
        ${a.AddressLine3 ? `, ${a.AddressLine3}` : ""}
        ${a.AddressLine4 ? `, ${a.AddressLine4}` : ""}
      </div></td>
      <td><div>${a.City || "-"}</div></td>
      <td><div>${a.State || "-"}</div></td>
      <td><div>${a.Pincode || "-"}</div></td>
    </tr>
  `
  ).join("")}
</table>
`;